export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/mute-icon.svg?a862c5724da7cdd59c1b5303fb3e9814";